import { WC_PROXY_BASE } from "../constants/wordpress";

export class WordPressApiError extends Error {
  constructor(message, status) {
    super(message);
    this.name = "WordPressApiError";
    this.status = status;
  }
}

export async function wpFetch(endpoint, options = {}) {
  const { searchParams = {}, method = "GET", body, ...fetchOptions } = options;
  const query = new URLSearchParams(searchParams);
  const queryString = query.toString();
  const url = `${WC_PROXY_BASE}${endpoint}${queryString ? `?${queryString}` : ""}`;

  const headers = {
    Accept: "application/json",
    ...fetchOptions.headers,
  };

  if (body) {
    headers["Content-Type"] = "application/json";
  }

  const response = await fetch(url, {
    method,
    ...fetchOptions,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });

  if (!response.ok) {
    let message = `WordPress API error (${response.status})`;
    try {
      const errorBody = await response.json();
      message = errorBody.message || message;
    } catch {
      // ignore parse errors
    }
    throw new WordPressApiError(message, response.status);
  }

  const data = await response.json();
  const total = Number(response.headers.get("X-WP-Total") || 0);
  const totalPages = Number(response.headers.get("X-WP-TotalPages") || 0);

  return { data, total, totalPages };
}
